module.exports = __webpack_public_path__ + "img/0Q3A5061_P_L_Wood_MockedUp.4bbcb096.jpg";